var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TitleWithRow", { attrs: { title: "Cônjuge:" } }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("InputSelect", {
            attrs: {
              label: "Estado civil",
              value: _vm.estadoCivil,
              obrigatorio: true,
              rulesInput: "required",
              opcoes: _vm.opcoesEstadoCivil,
              nomeAba: _vm.nomeAba,
              widthColumn: 6
            },
            on: { input: _vm.updateEstadoCivil }
          }),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "ml-forms", attrs: { span: 6 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: _vm.nomeAba + "/Renda familiar"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("Label", {
                          attrs: { label: "Renda familiar", obrigatorio: true }
                        }),
                        _vm._v(" "),
                        _c("AppInputDouble", {
                          class: { "input erro": errors.length },
                          attrs: {
                            name: "Renda familiar",
                            precision: 2,
                            onkeypress: _vm.onlyInputNumbers,
                            showAppend: true,
                            appendText: "R$",
                            value: _vm.rendaFamiliar
                          },
                          on: { input: _vm.updateRendaFamiliar }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "help erro",
                            staticStyle: { "margin-left": "1.2rem" }
                          },
                          [_vm._v(_vm._s(errors[0]))]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.estadoCivil === "CASADO" || _vm.estadoCivil === "UNIAO_ESTAVEL"
        ? _c(
            "div",
            [
              _c("TitleWithRow", { attrs: { title: "Dados do Cônjuge" } }),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      mode: "lazy",
                      name: _vm.nomeAba + "/Nome completo do cônjuge"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c(
                                "el-col",
                                { attrs: { span: 13 } },
                                [
                                  _c("Label", {
                                    attrs: {
                                      label: "Nome completo do cônjuge",
                                      obrigatorio: true
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    class: { "input erro": errors.length },
                                    attrs: {
                                      name: "Nome completo do cônjuge",
                                      placeholder:
                                        "Digite o nome completo do cônjuge",
                                      clearable: "",
                                      value: _vm.nome
                                    },
                                    on: { input: _vm.updateNome }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4277350836
                    )
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("InputSelect", {
                    attrs: {
                      label: "Regime de bens",
                      value: _vm.regimeBens,
                      obrigatorio: true,
                      rulesInput: "required",
                      opcoes: _vm.opcoesRegimeDeBens,
                      nomeAba: _vm.nomeAba,
                      widthColumn: 6
                    },
                    on: { input: _vm.updateRegimeDeBens }
                  }),
                  _vm._v(" "),
                  _c("validation-provider", {
                    attrs: {
                      rules: "required|cpf",
                      mode: "lazy",
                      name: _vm.nomeAba + "/CPF do cônjuge"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c(
                                "el-col",
                                { staticClass: "ml-forms", attrs: { span: 6 } },
                                [
                                  _c("Label", {
                                    attrs: {
                                      label: "CPF do cônjuge",
                                      obrigatorio: true
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "###.###.###-##",
                                        expression: "'###.###.###-##'"
                                      }
                                    ],
                                    class: { "input erro": errors.length },
                                    attrs: {
                                      name: "CPF do cônjuge",
                                      placeholder: "000.000.000-00",
                                      clearable: "",
                                      value: _vm.cpf
                                    },
                                    on: { input: _vm.updateCpf }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3277272565
                    )
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("InputSelect", {
                    attrs: {
                      label: "Sexo",
                      nomeAba: _vm.nomeAba,
                      obrigatorio: true,
                      rulesInput: "required",
                      opcoes: _vm.opcoesSexo,
                      widthColumn: 13,
                      value: _vm.sexo
                    },
                    on: { input: _vm.updateSexo }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("UFMunicipio", {
                    staticClass: "mt-2",
                    attrs: {
                      nomeAba: _vm.nomeAba,
                      municipioId: _vm.municipioId,
                      UF: _vm.UF,
                      ufObrigatorio: true,
                      municipioObrigatorio: true
                    },
                    on: {
                      "update:municipioId": _vm.updateMunicipioId,
                      "update:UF": _vm.updateUF,
                      "update:municipioNome": _vm.updateMunicipioNome
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bbb92718", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbb92718","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/FormulariosProntos/DadosConjuge/DadosConjuge.vue
// module id = null
// module chunks = 